import React from "react";
import PropTypes from "prop-types";
import CustomButton from "Samarth Module/components/buttons/CustomButton";
import OverviewToggle from "../utils/OverviewToggle";
import Excel from "../../../../../assets/images/Excel.svg";
import Slider from "../../../../../assets/images/sliders 1.svg";
import Expand from "../../../../../assets/images/expand.svg";
import CustomMultiSelect from "../utils/CustomMultiSelect";
export default function OverviewToolbar({
  styles,
  actionSuggested,
  options,
  onChange,
  onExport,
  onCustomize,
  onExpand,
  exportLoading,
  onSelectView,
  selectedView
}) {

  const handleExport = () => {
    if (exportLoading) return;
    console.log("[Export] button clicked");
    onExport?.();
  };
  const handleExpand = () => {
    onExpand?.();
  };
      // Handler for view change
    const handleViewChange = (selected) => {
        onSelectView?.(selected)
    };
  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "10px" }}>
      <span className={styles.title}>Overview</span>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
        <div className={styles.viewBox}>
          <OverviewToggle
            options={['Order Loss', 'Order Loss + MSTN']}
            defaultSelected={selectedView}
            onChange={handleViewChange}
          />
        </div>
        <div className={styles.filterWrapper}>
          <CustomMultiSelect
            options={options}
            value={actionSuggested}
            onChange={onChange}
          />
        </div>

        <div style={{ marginRight: "8px" }}>
          <CustomButton icon={Slider} label="Customise" type="mm-save" onClick={onCustomize} style={{border:"1px solid gray"}}/>
        </div>

        <div style={{ marginRight: "8px", opacity: exportLoading ? 0.6 : 1 }}>
          <CustomButton
            icon={Excel}
            label={exportLoading ? "Exporting..." : "Export"}
            type="mm-save"
            onClick={handleExport}
            disabled={!!exportLoading}
            style={{
              cursor: exportLoading ? "not-allowed" : "pointer"
            }}
          />
        </div>

        <div className={styles.segmentedBtn}>
          <button
            type="button"
            className={styles.segment}
            style={{ padding: "6px", background: "white", border: "1px solid #e5e7eb", cursor: "pointer" }}
            onClick={handleExpand}
            title="Expand / Zoom"
          >
            <img src={Expand} alt="Expand" className={styles.icon} />
          </button>
        </div>
      </div>
    </div>
  );
}

OverviewToolbar.propTypes = {
  styles: PropTypes.object,
  actionSuggested: PropTypes.array,
  options: PropTypes.array,
  onChange: PropTypes.func,
  onExport: PropTypes.func,
  onCustomize: PropTypes.func,
  onExpand: PropTypes.func,
  exportLoading: PropTypes.bool,
  onSelectView: PropTypes.func,
  selectedView: PropTypes.string,
};